<template>
  <!-- Sign Up Layout -->
  <div class="session-wrapper fade-in-up sign-up-page">
    <div class="container container-full-width">
      <div class="row">
        <div class=" mx-auto">
          <div class="row no-gutters align-items-center">
            <!-- <div class="card border-0 p-5 card-shadow"> -->
            <form
              class="session-form mb-4"
              action="javascript:void(0)"
              method="post"
            >
              <div class="social-widget mb-4">
                <h2 class="text-capitalize font-2x mb-4">
                  {{ $t("EditProfile") }}
                </h2>
              </div>
              <!-- Social widget closed -->
              <div class="form-group">
                <label for="password">{{ $t("Name") }}</label>
                <input
                  v-model="Model.name"
                  label="Name"
                  class="form-control form-control-lg"
                  aria-describedby="name"
                  :data-vv-as="$t('Name')"
                  placeholder="Enter Name"
                />
              </div>

              <div class="form-group">
                <label for="InputEmail1">{{ $t("Email") }}</label>
                <input
                  v-model="Model.email"
                  type="email"
                  class="form-control form-control-lg"
                  id="InputEmail1"
                  required
                  name="Email"
                  v-validate="'required|email'"
                  :data-vv-as="$t('Email')"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                />
              </div>

              <div class="form-group mb-4">
                <label for="c-password">{{ $t("PhoneNumber") }}</label>
                <input
                  v-model="Model.telephone"
                  type="text"
                  name="Phone"
                  class="form-control"
                  :data-vv-as="$t('PhoneNumber')"
                  aria-describedby="name"
                  placeholder="Enter Phone"
                />
              </div>
              <div class="modify-img flex justify-between mt-5">
                <input
                  type="file"
                  class="hidden"
                  ref="updateImgpersonalInput"
                  @change="updatepersonalImg"
                  accept="image/*"
                />
                <!-- <vs-button
                  class="mr-4"
                  type="flat"
                  @click="$refs.updateImgpersonalInput.click()"
                  >{{ $t("UpdateImage") }}</vs-button
                > -->
              </div>
              <div class="col-md-9 text-center mt-4">
                <button
                  type="submit"
                  class="rounded-pill btn btn-primary btn-block btn-lg submit-btn"
                  @click="Edit"
                  :disabled="!validateForm"
                >
                  {{ $t("SaveEdits") }}
                </button>
              </div>
            </form>
            <!-- session form closed -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- container closed -->
  </div>
  <!-- session Wrapper closed -->
</template>
<script>
import axios from "@/axios.js";
import { domain } from "@/globalComponents.js";

export default {
  data() {
    return {
      baseURL: domain,
      Image: null,
      Attachment: null,
      uploadUrl: "Common/UploadListFilesInFolderFilesUploads",
      Model: {
        name: "",
        email: "",
        telephone: "",
        profilePic: null,
      },
      ConfirmPassword: "",
    };
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() && this.Model.name !== "" && this.Model.email !== ""
        //  &&
        // this.Model.telephone !== ""
      );
    },
    appActiveUser() {
      debugger;
      return this.$store.state.AppActiveUser;
    },
  },

  methods: {
    updatepersonalImg(input) {
      debugger;
      if (input.target.files && input.target.files[0]) {
        let data = new FormData();
        data.append("file", input.target.files[0]);
        debugger;
        axios.post(this.baseURL + this.uploadUrl, data).then((response) => {
          this.Image = response.data;
        });
      }
    },
    Edit() {
      debugger;
      this.Model.profilePic = this.Image;
      this.$store
        .dispatch("auth/EditProfile", this.Model)
        .then(() => {
          this.$toasted.show(this.$t("showUpdate"), {
            theme: "outline",
            position: "top-center",
            duration: 5000,
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.Model.name = this.appActiveUser.FullName;
    this.Model.email = this.appActiveUser.Email;
    this.Model.telephone = this.appActiveUser.Phone;
  },
};
</script>
